import React, { useEffect, useRef, useState } from "react";
import { Cover, Intro, Projects, Contact, Footer } from "../";

import * as style from "./ParallaxExample.module.scss";

const ParallaxExample = () => {
  const [selectedSection, setSelectedSection] = useState(null);
  const refs = {
    projects: useRef(null),
    contact: useRef(null),
  };
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      window.scrollTo(
        0,
        refs[selectedSection].current.getBoundingClientRect().top
      );
    }
  }, [selectedSection]);

  return (
    <div className={style.root}>
      {<Cover />}

      {/*<Intro className={style.section} goToSection={setSelectedSection} />
      <Projects ref={refs.projects} className={style.section} />
      <Contact ref={refs.contact} className={style.section} />
      <Footer className={style.section} />*/}
    </div>
  );
};

export default ParallaxExample;
